var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRefundImg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.194,
    height: 23.194,
    viewBox: "0 0 23.194 23.194",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.6,0A11.6,11.6,0,1,0,23.2,11.6,11.6,11.6,0,0,0,11.6,0Zm6.623,13.052a6.743,6.743,0,1,1-6.354-7.782L10.744,4.2l.736-.772L13.2,5.069h0l.771.735-.735.772h0L11.6,8.3l-.772-.736,1.04-1.091a5.536,5.536,0,1,0,3.093,1.154l.739-.949A6.75,6.75,0,0,1,18.221,13.052Zm-8.857.512-.04-.092.991-.42.039.093a1.393,1.393,0,0,0,1.267.656c.254,0,1.082-.046,1.082-.645,0-.313-.354-.5-1.114-.591-.853-.1-2.023-.226-2.023-1.514,0-.79.591-1.342,1.586-1.489V8.955h1.069v.61a1.8,1.8,0,0,1,1.411.978l.045.092-.913.422-.046-.077a1.341,1.341,0,0,0-1.07-.471c-.3,0-.986.053-.986.542,0,.352.444.432,1.025.5.909.112,2.152.265,2.152,1.6a1.648,1.648,0,0,1-1.619,1.595v.692H11.153v-.659A2.09,2.09,0,0,1,9.364,13.564Z",
    transform: "translate(-0.002)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRefundImg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/refundImg.65e75065.svg";
export { ForwardRef as ReactComponent };